import { Component, Input, OnInit, inject } from '@angular/core';
import { FiltersConfigMutable } from '@scalefast/config-angular';
import { CategoryPageFilters, Filter, FilterSelected, FilterTag } from '@scalefast/core';
import { SearchResultsPageService } from '@scalefast/ecommerce-core';
import { CategoryPageCriteriaFiltersAdapter } from '@scalefast/sam';
import { AppFilterTemplateComponent } from './filter-template/filter-template.component';

type FilterCriteria = 'all' | 'sort' | 'crit';

@Component({
  selector: 'app-search-filter',
  template: `
    <app-filter-template
      [filters]="filtersCriteria"
      [tagsArray]="tagsArray"
      [filterCriteria]="filterCriteria"
      (filterEvent)="filterChange($event)"
      (removeFilterTagEvent)="removeTagEvent($event)"
      (createFilterTagEvent)="createTagEvent($event)"
      (removeAllTagsEvent)="resetFilters()"
    />
  `,
  standalone: true,
  imports: [AppFilterTemplateComponent],
})
export class AppSearchFilterComponent implements OnInit {
  @Input() categoryId!: string;
  @Input() filterCriteria: string = 'all';

  filterService = inject(SearchResultsPageService);
  filtersCriteria: FiltersConfigMutable['filtersList'];
  tagsArray: Array<FilterTag> = [];

  constructor() {
    this.filtersCriteria = this.filterService.loadFiltersCriteria();
  }

  ngOnInit(): void {
    this.filtersCriteria = this.filterService.removeExcludedFilters(this.filtersCriteria, this.categoryId);
  }

  filterChange(event: Filter) {
    const filters = CategoryPageCriteriaFiltersAdapter.buildPartialFiltersFromMultiSelect(event);
    this.filterService.setFilters(filters);
  }

  removeTagEvent(event: Filter) {
    this.filtersCriteria = this.filterService.updateFilterChangedInLoadCriterial(event, this.filtersCriteria);
    const filters = CategoryPageCriteriaFiltersAdapter.buildPartialFiltersFromMultiSelect(event);
    this.filterService.setFilters(filters);
  }

  resetFilters() {
    const emptyFilters: CategoryPageFilters = { offset: 1, pageSize: 12, filters: Array(0) };
    this.filtersCriteria = this.filterService.resetFilters();
    this.filterService.setFilters(emptyFilters);
  }

  createTagEvent(event: { tagList: Array<FilterSelected>; filter: FiltersConfigMutable['filtersList'] }) {
    const { tagList, filter } = event;
    this.tagsArray = [JSON.parse(JSON.stringify(this.filterService.createFilterTag(tagList, filter)))];
  }
}
